import { useMutation } from 'react-query';
import { AnchorAPI } from 'modules/AnchorAPI';

function useSetCurrentWebStationId() {
  const { mutate, status } = useMutation((webStationId: string) => {
    return AnchorAPI.setCurrentWebStationId(webStationId);
  });

  return { setCurrentWebStationId: mutate, status };
}

export { useSetCurrentWebStationId };
